import { render, staticRenderFns } from "./FormControlModulestructureBrowser.vue?vue&type=template&id=3455210c&scoped=true"
import script from "./FormControlModulestructureBrowser.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureBrowser.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureBrowser.vue?vue&type=style&index=0&id=3455210c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455210c",
  null
  
)

export default component.exports